<template>
  <div class="hundred_percent_form left_form">
    <!-- <div class="title">
      <span>APP版本信息</span>
    </div>-->
    <el-form
      :label-position="labelPosition"
      v-loading="loading"
      ref="form"
      :model="form"
      label-width="100px"
      :rules="Version"
    >
      <el-form-item label="App版本" prop="versionsize">
        <el-input v-model="form.versionsize" placeholder="请填写App版本" clearable></el-input>
      </el-form-item>
      <el-form-item label="是否强制更新">
        <el-radio-group v-model="form.versiontype">
          <el-radio :label="0">是</el-radio>
          <el-radio :label="1">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="最低运行版本" prop="versionnum">
        <el-input v-model="form.versionnum" placeholder="请填写最低运行版本" clearable></el-input>
      </el-form-item>
      <el-form-item label="App版本名称">
        <el-input v-model="form.versionexplain" placeholder="请填写App名称" clearable></el-input>
      </el-form-item>
      <el-form-item label="下载地址">
        <el-input v-model="form.versiondownurl" placeholder="请填写下载地址" clearable></el-input>
      </el-form-item>
      <el-form-item label="更新公告">
        <el-input type="textarea" rows="6" placeholder="请填写更新公告" v-model="form.versionurl"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="formSubmit" :loading="formLoading">保 存</el-button>
        <el-button @click="onCancel">取 消</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { versionGetInfo, versionEdit } from "../../api/setting/version";
export default {
    data() {
        var versionS = (rule, value, callback) => {
            if (!value) {
                return callback(new Error("请输入积分"));
            } else {
                var reg = /^\d+$|^\d+[.]?\d+$/;
                if (reg.test(value)) {
                    callback();
                } else {
                    return callback(new Error("请输入数字"));
                }
            }
        };
        return {
            loading: true,
            formLoading: false,
            form: {
                versionid: "",
                versionsize: "",
                versiontype: "",
                versionnum: "",
                versionexplain: "",
                versionurl: "",
                versiondownurl: ""
            },
            Version: {
                versionsize: {
                    validator: versionS,
                    trigger: "blur"
                },
                versionnum: {
                    validator: versionS,
                    trigger: "blur"
                }
            },
            labelPosition: "left"
        };
    },
    methods: {
        onCancel() {
            this.getInfo();
        },
        getInfo() {
            this.loading = true;
            versionGetInfo()
                .then(response => {
                    if (response.code) {
                        this.$message.error(response.message);
                    }
                    if (response.data) {
                        this.form = response.data;
                    }
                    setTimeout(() => {
                        this.loading = false;
                    }, 0.3 * 1000);
                })
                .catch(() => {});
        },
        formSubmit() {
            this.$refs["form"].validate(valid => {
                if (valid) {
                    this.formLoading = true;
                    let data = Object.assign({}, this.form);
                    versionEdit(data).then(response => {
                        this.formLoading = false;
                        if (response.code) {
                            this.$message.error(response.message);
                            return false;
                        }
                        this.$message.success("操作成功");
                        //刷新表单
                        this.form = response.data;
                    });
                }
            });
        }
    },
    created() {
        // 加载版本数据
        this.getInfo();
    }
};
</script>

<style type="text/scss" lang="scss">
body {
    margin: 0;
}
.form {
    padding: 20px;
    width: 40%;
}
.title {
    color: #606266;
    text-align: center;
    font-size: 18px;
    margin: 30px 0;
}
</style>
